module.exports = __webpack_public_path__ + "img/qy_0.42677b0f.png";